﻿$.fn.dxCtrlItemGridTemplate = function custom_dxCtrlItemGridTemplate(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlitemgridtemplate dx-ctrl");
        this.createInstance(new cdxCtrlItemGridTemplate(this, option));
    }
    return this;
}

window.cdxCtrlItemGridTemplate = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.alignItem == "undefined") option.alignItem = "left"
    if (typeof option.typeGrille == "undefined") option.typeGrille = "Détails"

    var objTemplate = null
    var objPlus = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")
        //container.css("display", "inline-block")
        container.css("vertical-align", "middle")
        container.css({
            "align-items": "center",
            "justify-content": "center",
            "display": "flex",
        })
        //container.css("position", "relative")

        var $Table = $("<table style='width:100%;table-layout:fixed;height:100%;'/>").appendTo(container) //rajout height:100%
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdTemplate = $("<td style='width:100%;vertical-align:middle;'/>").appendTo($Tr)
        var $TdPlus = $("<td style='width:75px;text-align:right;font-family:barlow condensed;vertical-align:middle;font-size:90%;opacity:0.5;line-height:1.3;' class='tdplus'/>").appendTo($Tr)

        if (typeof option.itemTemplateGrille == 'undefined') {
            var objBase = null
            if (option.dataTemplateDisplay.id_table_key == 0) {
                objBase = new cObjetFile(option.dataTemplateDisplay, option.bddCtrl)
            } else {
                objBase = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.dataTemplateDisplay.id_table_key).nom) //, option.dataTemplateDisplay.id_key)
            }
            objBase.itemTemplateGrille($TdTemplate, option.dataTemplateDisplay, option.typeGrille, option.optionTemplate)
        } else {
            option.itemTemplateGrille($TdTemplate, option.dataTemplateDisplay, option.typeGrille, option.optionTemplate)
        }

        //var paddingBottom = parseInt($(container.parent()[0]).css("padding-top").replace("px",""))
        //var $DivPlus = $("<div style='font-family:barlow condensed;position:absolute;bottom:-" + (3 + paddingBottom) + "px;opacity:0.5;font-size:100%;min-width:1px;white-space:nowrap;overflow:hidden;' class='divplus'/>").appendTo(container)
        ////if (option.alignItem == "right") {
        ////    $DivPlus.css("left", "3px")
        ////    $DivPlus.css("text-align", "left")
        ////}
        ////else {
        ////    $DivPlus.css("right", "3px")
        ////    $DivPlus.css("text-align", "right")
        ////}
        //if (option.alignItem == "right") {
        //    $DivPlus.css("left", "0px")
        //    $DivPlus.css("text-align", "left")
        //    //$DivPlus.css("text-align", "left")
        //}
        //else {
        //    $DivPlus.css("right", "0px")
        //    $DivPlus.css("text-align", "right")
        //    //$DivPlus.css("text-align", "right")
        //}
        if (typeof option.itemTemplateGrillePlus == 'undefined') {
            var objPlus = null
            if (option.dataTemplatePlus.id_table_key == 0) {
                objPlus = new cObjetFile(option.dataTemplatePlus, option.bddCtrl)
            } else {
                objPlus = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.dataTemplatePlus.id_table_key).nom) //, option.dataTemplateDisplay.id_key)
            }
            objPlus.itemTemplateGrillePlus($TdPlus, option.dataTemplatePlus, option.typeGrille, option.optionTemplate)
        } else {
            option.itemTemplateGrillePlus($TdPlus, option.dataTemplatePlus, option.typeGrille, option.optionTemplate)
        }

        if (option.optionGrid && option.optionGrid.hideItemPlus) {
            $TdPlus.hide()
        } else {
            resizeObserver.mAdd(container, function () {
                if (container.innerWidth() < 400) { $TdPlus.hide() }
                else { $TdPlus.show() }
            })()
        }

    }

    mConstruit();
}